"use strict";

export class SvgLogo {
  constructor() {
    //
  }
}
